import React from 'react';
import { ArrowLeft, Download } from 'lucide-react';
import { RESULTS_SECTION_STRINGS } from '../../constants/appConstants';
import styles from './SearchResultsTopBar.module.scss';

const SearchResultsTopBar = ({ filteredCount, totalCount, onBack, onExport }) => (
  <div className={styles.topBar}>
    <div className={styles.topBarInner}>
      <button className={styles.backBtn} onClick={onBack}>
        <ArrowLeft size={18} />
        <span>{RESULTS_SECTION_STRINGS.TOP_BAR.BACK}</span>
      </button>

      <div className={styles.topBarRight}>
        <div className={styles.resultCount}>
          <span className={styles.countNumber}>{filteredCount}</span>
          <span className={styles.countLabel}>
            {RESULTS_SECTION_STRINGS.TOP_BAR.OF_PRODUCTS(totalCount)}
          </span>
        </div>

        <button className={styles.exportBtn} onClick={onExport}>
          <Download size={15} />
          <span>{RESULTS_SECTION_STRINGS.BUTTONS.EXPORT}</span>
        </button>
      </div>
    </div>
  </div>
);

export default React.memo(SearchResultsTopBar);
